module.exports = __webpack_public_path__ + "static/media/text-format-remove.65fa1b7d.svg";